import clsx from "clsx";
import React from "react";
import { MenuProps, MenuItem, ListItemText, ListItemIcon } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { ThreadsDto } from "@growth-machine-llc/stridist-api-client";
import { Menu } from "../menu/Menu";
import {
  Archive,
  MailOpen as MarkAsRead,
  Mail as MarkAsUnRead,
} from "lucide-react";

const useStyles = makeStyles((theme) => ({
  root: {
    zIndex: "9999 !important" as any,
  },
}));

export interface ThreadMenuProps extends MenuProps {
  thread: ThreadsDto;
  handleToggleArchive: (event: any) => void;
  handleToggleRead: (event: any) => void;
  disabled?: boolean;
}

export function ThreadMenu(props: ThreadMenuProps) {
  const {
    className,
    thread,
    onClose,
    handleToggleArchive,
    handleToggleRead,
    disabled,
    ...other
  } = props;
  const { id, read } = thread;
  const s = useStyles();

  return (
    <Menu
      id={id.toString()}
      MenuListProps={{ dense: true }}
      onClose={onClose}
      className={clsx(s.root, className)}
      {...other}
    >
      <MenuItem onClick={handleToggleArchive} disabled={disabled} dense>
        <ListItemIcon children={<Archive />} />
        <ListItemText primary="Archive" />
      </MenuItem>

      <MenuItem onClick={handleToggleRead} disabled={disabled} dense>
        <ListItemIcon children={read ? <MarkAsUnRead /> : <MarkAsRead />} />
        <ListItemText primary={read ? "Mark as Unread" : "Mark as Read"} />
      </MenuItem>
    </Menu>
  );
}
